module.exports = __webpack_public_path__ + "img/jslc2.80f1bebb.png";